import { useCallback, useState } from 'react'

import { useInterval } from '@pepper/ui'

type UseScrollReturnType = {
  cardsLayoutScroll: (ref: unknown) => void
  showBottom: boolean
}

const waitTime = 5000

export const useScroll = (): UseScrollReturnType => {
  const [showBottom, setShowBottom] = useState(false)

  const { clear } = useInterval(() => setShowBottom(true), waitTime)
  // The scroll listener
  const handleScroll = useCallback(() => {
    // TODO If scroll event happens before 5 seconds cancel the show event
    clear()
    setShowBottom(false)
  }, [clear, setShowBottom])

  // Attach the scroll listener to the div
  const cardsLayoutScroll = useCallback(
    ref => {
      if (!ref) return

      const div = ref
      div.addEventListener('scroll', handleScroll)
    },
    [handleScroll]
  )

  return { cardsLayoutScroll, showBottom }
}
